module.exports = __webpack_public_path__ + "b6dafa2f7a32215543e11419d1048632.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/tourWorks/room6/audio1/06_MCA A La Belle Etoile.mp3
// module id = 786
// module chunks = 0